module.exports = __webpack_public_path__ + "img/blank-comic-book_B0991LPZV7.31854900.jpg";